import type {TopicScoreMap} from './buildProgressScoreMap';

export function buildRelatedScoresFromMap(topicScores: TopicScoreMap): Record<string, number> {
  return Object.entries(topicScores).reduce<Record<string, number>>((acc, [topic, value]) => {
    acc[topic] = value.score;
    return acc;
  }, {});
}
